
(function () {
  /* One copy per page. The snippet is deliberately loaded from more than one
     place in some themes so that losing one of them does not lose the leads,
     and whichever runs first claims the page. */
  if (window.__laLeadMirror) { return; }
  window.__laLeadMirror = true;

  /* The system's public intake. It has to be reachable from a browser for a
     mirror like this to work at all; that is the one cost of copying forms
     rather than replacing them. Nothing secret goes to it and nothing comes
     back, and the server refuses a repeat of the same inquiry. */
  var ENDPOINT = "https://script.google.com/macros/s/AKfycbwbI3d64y1WHoi4v9dX2N5uhfUhrkd1--e7d2SKpXRiy0ZB8bQDjxe--N6fPEfXGv1_/exec";
  var SCHOOL = "LA";

  /* Shopify names its fields contact[Whatever The Merchant Typed]. Match on
     the meaning rather than the exact wording, so renaming a label on a form
     cannot quietly stop a field arriving. */
  var MAP = [
    ["first",        /^first/i],
    ["last",         /^last/i],
    ["name",         /^(name|full ?name)$/i],
    ["email",        /e-?mail/i],
    ["phone",        /phone|mobile|tel/i],
    ["course",       /course|program|interest/i],
    ["timeline",     /ready to start|timeline|when/i],
    ["funding",      /funding|finance|budget|pay/i],
    ["contact_preference", /preferred contact|contact method|reach you/i],
    ["goal",         /goal|why|motivation/i],
    ["experience",   /experience|flown|certificate|rating/i],
    ["availability", /availability|days|schedule/i],
    ["message",      /message|comment|question|anything else/i]
  ];

  function label(name) {
    var m = /^contact\[(.+)\]$/.exec(name);
    return m ? m[1] : name;
  }

  function collect(form) {
    var d = { school: SCHOOL, site: SCHOOL, source: "Website form (Shopify)" };
    var extra = [];
    var els = form.elements, i, el, key, lab, hit, j;

    for (i = 0; i < els.length; i++) {
      el = els[i];
      if (!el.name || el.disabled) continue;
      if (el.type === "hidden" && el.name === "utf8") continue;
      if (el.type === "checkbox" || el.type === "radio") { if (!el.checked) continue; }
      var val = String(el.value == null ? "" : el.value).trim();
      if (!val) continue;

      lab = label(el.name);
      hit = null;
      for (j = 0; j < MAP.length; j++) { if (MAP[j][1].test(lab)) { hit = MAP[j][0]; break; } }

      if (!hit) { if (el.name !== "form_type") extra.push(lab + ": " + val); continue; }
      /* First value wins, so a stray second field cannot overwrite a real one. */
      if (hit === "first" || hit === "last") { d[hit] = d[hit] || val; continue; }
      if (d[hit]) { extra.push(lab + ": " + val); continue; }
      d[hit] = val;
    }

    if (!d.name) {
      d.name = [d.first || "", d.last || ""].join(" ").trim();
    }
    delete d.first; delete d.last;

    /* Nothing a visitor typed is thrown away just because no field matched it. */
    if (extra.length) d.message = (d.message ? d.message + "\n" : "") + extra.join("\n");

    d.form = form.id || form.getAttribute("data-lead-form") || "contact";
    d.page_source = location.pathname + location.search;
    return d;
  }

  function send(d) {
    /* The intake reads the inquiry from the top level of the body, alongside
       the action - not from a nested object. Nesting it was the original
       mistake: the request arrived, the server looked for an email and a phone
       number where it expects them, found neither, and refused the lead as
       having no contact details. It said so in the reply, but a beacon never
       reads the reply, so it failed in complete silence. Keep this flat. */
    var payload = { action: "webLead" };
    for (var k in d) {
      if (Object.prototype.hasOwnProperty.call(d, k)) payload[k] = d[k];
    }
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, body)) return;
    } catch (e) {}
    try {
      fetch(ENDPOINT, { method: "POST", body: body, keepalive: true, mode: "no-cors" });
    } catch (e2) {}
  }

  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== "FORM") return;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== "contact") return;   /* never the cart or search */
    try { send(collect(form)); } catch (e) {}
  }, true);
})();
